import script from "./BottomInformation.vue?vue&type=script&setup=true&lang=js"
export * from "./BottomInformation.vue?vue&type=script&setup=true&lang=js"

import "./BottomInformation.vue?vue&type=style&index=0&id=44654ca9&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\Vue-Projects\\ForestPage\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44654ca9"]])

export default __exports__